/* eslint-disable @typescript-eslint/no-explicit-any */
export function getDatepickerConfig({
  isInline,
  cultureCode,
  dateFormat,
  ...props
}: any) {
  return {
    inline: isInline,
    prevHtml: '<<',
    nextHtml: '>>',
    navTitles: {
      days: 'MMMM <i>yyyy</i>',
    },
    dateFormat: dateFormat
      ? dateFormat
      : cultureCode.startsWith('es')
        ? 'dd-MM-yyyy'
        : cultureCode.startsWith('en') && 'MM/dd/yyyy',
    ...props,
  };
}
